import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * get all friends of moose
 */
export function getFriends(callback) {

  database.ref('friends').once('value')
    .then((snapshot) => {
      const friends = snapshot.val();
      callback(true, friends, null);
    });
}

/**
 * Create new friend
 */
export function createNewFriend (data, callback) {
  var newId = database.ref().child('friends').push().key;
  data["id"] = newId;

  database.ref('friends/' + newId).set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

/**
 * Edit friend
 */
export function editFriend (id, data, callback) {

  database.ref('friends/' + id).update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  });
}

export function archiveFriendOffer(id, data, callback) {
  database.ref('friends')
    .child(id)
    .child('offersArchive')
    .child(data.offerId)
    .set(data, function(error) {
       callback(error);
    })
}

/**
 * Delete friend
 */
export function deleteFriend(id, callback) {
  database.ref('friends').child(id).remove(function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, id, null);
    }
  });
}
